import { type QueryClient, queryOptions } from "@tanstack/react-query";

const API_URL = import.meta.env.VITE_API_URL;

export interface Data {
	whitelistedCollections: string[];
	collections: Record<string, Collection>;
	marketplaceWallets: string[];
	tokenAddresses: {
		usdc: string;
		credits: string;
	};
	rarities: string[];
	kmsAddresses: {
		minter: string;
		inventory: string;
		treasury: string;
		buyback: string;
	};
}

interface Collection {
	name: string;
	type: "ERC721A" | "ERC1155";
	address: string;
}

export const getInventoryConfig = () => {
	return queryOptions({
		queryKey: ["inventory-config"],
		queryFn: async () => {
			const resp = await fetch(`${API_URL}/inventory/config`, {
				method: "GET",
				credentials: "include",
			});
			if (!resp.ok) {
				return null;
			}
			const config = await resp.json();
			return config?.data as Data;
		},
		staleTime: 60 * 1000,
		retry: false,
	});
};

export function findCollectionByAddress(
	collections: Record<string, Collection>,
	address: string,
) {
	return Object.values(collections).find(
		(c) => c.address.toLowerCase() === address.toLowerCase(),
	);
}

export const getCollection = async ({
	queryClient,
	collectionAddress,
}: {
	queryClient: QueryClient;
	collectionAddress: string;
}) => {
	const config = await queryClient.ensureQueryData(getInventoryConfig());
	const collections = config?.collections ?? {};
	const collection = findCollectionByAddress(collections, collectionAddress);

	if (!collection) {
		throw new Error("Collection not found");
	}

	return collection;
};
